export default function getRowId(stageRunId: string, outputSampleId: string): string {
  return `${stageRunId}:${outputSampleId}`;
}
